import { render, staticRenderFns } from "./ReferralPoolProposeTimePage.vue?vue&type=template&id=47a8f678"
import script from "./ReferralPoolProposeTimePage.vue?vue&type=script&lang=js"
export * from "./ReferralPoolProposeTimePage.vue?vue&type=script&lang=js"
import style0 from "./ReferralPoolProposeTimePage.vue?vue&type=style&index=0&id=47a8f678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports